import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'ws-scripts/modules/common';
import { setClassNames } from 'ddc-classnames-js';
import SpotIcon from './SpotIcon';

const CtaCard = ({
	buttonLabel,
	headingLabel,
	contentLabel,
	iconName,
	position,
	url,
	accessibleDescription,
	isGridLayout,
	forwardedRef
}) => {
	const labels = useLabels();
	return (
		<li
			data-location={`cta-card-${position}`}
			ref={forwardedRef}
			key={position}
			className={setClassNames([
				'box',
				'box-border',
				'vehicle-card',
				'vehicle-card-detailed',
				isGridLayout ? null : 'vehicle-card-horizontal'
			])}
		>
			<div
				className={setClassNames([
					'cta-card-body',
					'd-md-flex',
					'ddc-font-size-small',
					'align-items-center',
					'text-center',
					isGridLayout ? 'd-flex flex-column' : null
				])}
			>
				<div
					className={setClassNames([
						'cta-card-media-wrapper',
						'px-0',
						isGridLayout ? 'col-sm-12' : 'col-sm-4 col-lg-3'
					])}
				>
					<div className="cta-card-media-icon line-height-reset">
						<SpotIcon spotIconName={iconName} spotIconSize="100" />
					</div>
				</div>
				<div
					className={setClassNames([
						'cta-card-content-wrapper',
						'align-items-center',
						'pb-4',
						'col-12',
						isGridLayout
							? null
							: 'col-sm-8 col-lg-9 pt-md-4 d-xl-flex'
					])}
				>
					<div
						className={setClassNames([
							'cta-card-content-container',
							'p-0',
							'text-center',
							'col-12',
							isGridLayout ? null : 'col-lg-7'
						])}
					>
						{headingLabel && (
							<h3
								id={`ctaCard-${position}-heading`}
								className="widgetHeading mt-4 mb-0"
							>
								{labels.get(headingLabel)}
							</h3>
						)}
						<p
							className={setClassNames([
								'm-0',
								'mt-4',
								isGridLayout
									? 'px-4 px-md-8 px-xl-6'
									: 'px-2 mb-xl-4'
							])}
						>
							{labels.getHTML(contentLabel)}
						</p>
					</div>
					<div
						className={setClassNames([
							'cta-card-btn-container',
							'p-0',
							'mx-auto',
							'col-12',
							isGridLayout ? null : 'col-lg-5'
						])}
					>
						<a
							type="button"
							className="btn btn-sm btn-primary mt-4 mb-3"
							href={url}
							title={labels.get(accessibleDescription)}
						>
							{labels.get(buttonLabel)}
						</a>
					</div>
				</div>
			</div>
		</li>
	);
};

const ReferencedCtaCard = React.forwardRef((props, ref) => {
	return <CtaCard {...props} forwardedRef={ref} />;
});

CtaCard.propTypes = {
	buttonLabel: PropTypes.string.isRequired,
	headingLabel: PropTypes.string.isRequired,
	contentLabel: PropTypes.string.isRequired,
	iconName: PropTypes.string.isRequired,
	position: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
	accessibleDescription: PropTypes.string.isRequired,
	isGridLayout: PropTypes.bool.isRequired,
	forwardedRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	])
};

export default ReferencedCtaCard;
